(function($){

	let newsletterForm = $('#bar-newsletter');

	if(!newsletterForm || newsletterForm.length < 1){
		return;
	}

	newsletterForm.validate({

        ignore: [],
        rules: {
        	"first_name" : {
	            required: true
	        },
	        "last_name" : {
	            required: true
	        },
			"email" : {
	            required: true,
	            email: true
	        },
	        "acceptance" : {
	            required: true
	        },
        },
        messages: {
        	"first_name" : {
        		required: 'The field First name is required'
        	},
        	"last_name" : {
        		required: 'The field Last name is required'
        	},
        	"email" : {
        		required: 'The field Email is required'
        	},
        	"acceptance" : {
        		required: 'You must accept our Privacy policy'
        	}
        },
        errorPlacement: function(error, element) {
            error.appendTo( $(element).closest("#bar-newsletter").find('#bar-form-alert') );
        },
        highlight: function(element) {
            $(element).closest(".bar-form-field").addClass('bar-form-field--has-error');
        },
        unhighlight: function(element) {
            $(element).closest(".bar-form-field").removeClass('bar-form-field--has-error');
        },

        submitHandler: function(form){

            $.ajax({
		        type: "POST",
		        dataType: "json",
		        url: var_bar_ajax.url,
		        data: {
		        	action : var_bar_ajax.action,
					nonce: var_bar_ajax.nonce,
					callback: 'bar-register-newsletter',
					formData: $(form).serialize(),
		        },
		        success: function(response){
		        	// console.log(response);
		        	// return;

		        	let type = response['result'].toUpperCase();

		        	let msg = type + '<br>';

		        	if( response[0]['message'].length > 0 ){
		        		response[0]['message'].forEach(element => msg += (element + '<br>') );
		        	}

		        	newsletterForm.find('#bar-form-alert').html('').append(msg);

		        	if( response['result'] == 'success' ){
		        		$(form)[0].reset();
		        	}


		        },
		        error : function(jqXHR, textStatus, errorThrown) {
		        	console.log('Error desconocido');
		        	console.log(errorThrown);
		        }

		    }); // $.ajax
        }
    });

})(jQuery)